import React from 'react';
import { Download, Smartphone, FileCheck } from 'lucide-react';

const TaxAppDownload = () => {
  return (
    <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
      <div className="luxury-container">
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <div style={{ marginBottom: '16px' }}>
            <Smartphone size={40} strokeWidth={1.5} color="var(--accent-gold)" style={{ margin: '0 auto' }} />
          </div>
          <h2 className="heading-1" style={{ marginBottom: '16px' }}>
            Tax To Go Mobile App
          </h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '700px', margin: '0 auto' }}>
            Access your tax documents, track your return status, and manage your tax preparation on the go
          </p>
        </div>

        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '32px', marginBottom: '48px' }}>
            <div style={{ textAlign: 'center', padding: '32px 24px' }}>
              <FileCheck size={32} strokeWidth={1.5} color="var(--text-primary)" style={{ margin: '0 auto 16px' }} />
              <h3 className="heading-3" style={{ marginBottom: '8px' }}>Secure Document Upload</h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>Safely submit your tax documents from anywhere</p>
            </div>
            
            <div style={{ textAlign: 'center', padding: '32px 24px' }}>
              <Download size={32} strokeWidth={1.5} color="var(--text-primary)" style={{ margin: '0 auto 16px' }} />
              <h3 className="heading-3" style={{ marginBottom: '8px' }}>Easy Access</h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>Download and review your returns anytime</p>
            </div>
            
            <div style={{ textAlign: 'center', padding: '32px 24px' }}>
              <Smartphone size={32} strokeWidth={1.5} color="var(--text-primary)" style={{ margin: '0 auto 16px' }} />
              <h3 className="heading-3" style={{ marginBottom: '8px' }}>Real-Time Updates</h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>Stay informed about your return status</p>
            </div>
          </div>

          <div style={{ textAlign: 'center' }}>
            <p className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '24px' }}>
              Download the Tax To Go app and experience seamless tax preparation
            </p>
            <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <button className="btn-primary" style={{ minWidth: '200px' }}>
                <Download size={16} />
                Coming Soon
              </button>
            </div>
            <p className="body-small" style={{ color: 'var(--text-light)', marginTop: '16px', fontStyle: 'italic' }}>
              Available for iOS and Android
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TaxAppDownload;